import { RadioField as select } from './radio-field'
import { Textarea as textarea } from './text-area'
import { InputField as input } from './input-field'
import { CheckboxField as checkbox } from './checkbox-field'

export default {
  checkbox,
  select,
  textarea,
  input,
}
